import React, {Component} from 'react';

import PropTypes from 'prop-types';




class RouteTitle extends Component {

	render() {
		return (
			<div className="row">
	            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
	                <div className="page-header">
	                    <h2 className="pageheader-title">{this.props.title}</h2>
	                    <p className="pageheader-text">{this.props.summary}</p>
	                    
	                </div>
	            </div>
	        </div>
		)
	}

}

RouteTitle.propTypes = {
	title : PropTypes.string.isRequired,
	summary : PropTypes.string,
	funnels : PropTypes.array
}


export default RouteTitle;